/**
 * 微信环境配置
 *
 * @type {{test: number, apiList: string[], debug: boolean}}
 */
let wxconfig = {
  isTest: 0, // 0--生产环境  1--开发环境
  // 是否开启微信debug
  debug: false
}
export default wxconfig



// WEBPACK FOOTER //
// ./src/wx/config.js